import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet-detail",
  "use": "icon-sheet-detail-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"icon-sheet-detail\">\n  <g stroke=\"currentColor\">\n    <rect fill=\"transparent\" x=\"1.5\" y=\"1.5\" width=\"12\" height=\"14\" rx=\"3\" />\n    <path fill=\"transparent\" d=\"M13.168 7.51h2.444C16.937 7.51 18 8.717 18 10.218v2.5c0 1.501-.957 2.794-2.283 2.794H10\" />\n    <path stroke-width=\"1.2\" stroke-linecap=\"round\" d=\"M4 5.5h4M4 8.5h7M4 12h6\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol